<template>
  <div>
    <h1>
      Thank you!
    </h1>
    <p>
      Your Air Quality Site Request has been processed and is waiting review.
    </p>
    <p>
      Thank you for using the Cook County Department of Environment &amp; Sustainability on-line permit application
      system. After approval of your permit application by the department, it will be emailed to the address you
      provided with your application.
    </p>
    <dl class="row">
      <dt class="col-12">For Customer Service:</dt>
      <dt class="col-sm-3">Hours:</dt>
      <dd class="col-sm-9">8:30am - 4:30pm</dd>
      <dt class="col-sm-3">Phone:</dt>
      <dd class="col-sm-9">312-603-8200 (and follow appropriate prompt)</dd>
    </dl>
  </div>
</template>
<script>
export default {
  name: 'SiteRequestThankYou',
  data() {
    return {
    };
  },
  mounted() {
  },
};

</script>
